import { useEffect, useState } from 'react';

import { accountAlertsQuery, subscribe } from '@/lib/firestore';
import type { Alert } from '@/schemas';

export type AlertWithId = Alert & { id: string };

export function useAlerts(aid: string | null): {
  alerts: AlertWithId[];
  loading: boolean;
} {
  // Derived loading: see useMyMemberships for the why.
  const [state, setState] = useState<{ loadedAid: string | null; data: AlertWithId[] }>({
    loadedAid: null,
    data: [],
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: [] });
      return;
    }
    setState({ loadedAid: null, data: [] });
    const unsub = subscribe<Alert>(accountAlertsQuery(aid), (rows) => {
      setState({ loadedAid: aid, data: rows });
    });
    return unsub;
  }, [aid]);
  return {
    alerts: state.loadedAid === aid ? state.data : [],
    loading: aid != null && state.loadedAid !== aid,
  };
}
